<div *ngIf="fileName" class="file-display">
  <span class="downloadText" *ngIf="downloadUrl" (click)="downloadFile($event)">{{fileName}}</span>
  <span *ngIf="!downloadUrl">{{fileName}}</span>
</div>
